<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row style="align-items: center">
        <v-col>
          <h3>Menus</h3>
        </v-col>
        <v-col class="text-right">
          <v-btn @click="changeEditMode()" v-permission="'menu'" color="blue-grey lighten-1" depressed dark>
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="4">
          <TheSearchInput v-model="search" />
        </v-col>
      </v-row>
    </v-card>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-data-table :headers="headers" :items="menus" :search="search" :loading="loading">
        <template v-slot:[`item.iconMenu`]="{ item }">
          <v-icon small class="mr-2">{{ item.iconMenu }}</v-icon>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <TheToolTip label="Editar Menu">
            <v-icon class="ma-1" v-permission="'user'" @click="editMenu(item)">
              mdi-pencil
            </v-icon>
          </TheToolTip>
          <TheToolTip label="Deletar Menu">
            <v-icon class="ma-1" v-permission="'user'" @click="deleteMenu(item)">
              mdi-delete
            </v-icon>
          </TheToolTip>
        </template>
      </v-data-table>
    </v-card>

    <TheDialog v-model="dialog" :title="formTitle" :dialog="dialog">
      <template>
        <v-form ref="form">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field outlined v-model="menu.idMenu" label="ID do Menu" :disabled="editing" color="primary" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field outlined v-model="menu.nameMenu" label="Nome do Menu" color="primary" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field outlined v-model="menu.pathMenu" label="Rota do Menu" color="primary" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="menus"
                  v-model="menu.menuParent"
                  label="Menu Pai"
                  item-text="nameMenu"
                  item-value="idMenu"
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="12">
                <v-select
                  :items="icons"
                  v-model="menu.iconMenu"
                  label="Icone do menu"
                  item-text="icon"
                  item-value="icon"
                  clearable
                  outlined
                >
                  <template slot="item" slot-scope="data">
                    <p>
                      <v-icon>{{ data.item.icon }}</v-icon>
                      {{ data.item.icon }}
                    </p>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </template>
      <template v-slot:actions>
        <v-btn color="primary" depressed dark @click="reset">Reset</v-btn>
        <div class="flex-grow-1"></div>
        <v-btn color="primary" depressed dark @click="saveMenu" v-show="!editing">Save</v-btn>
        <v-btn color="primary" depressed dark @click="saveEditedMenu" v-show="editing">Alterar</v-btn>
      </template>
    </TheDialog>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'

import TheDialog from '@/components/TheDialog'
import TheToolTip from '@/components/TheToolTip'
import TheSearchInput from '@/components/TheSearchInput'

export default {
  name: 'Menus',
  components: { TheDialog, TheToolTip, TheSearchInput },
  data: () => ({
    loading: false,
    search: '',
    editing: false,
    dialog: false,
    menu: {},
    menus: [],
    headers: [
      { text: 'ID', value: 'idMenu', width: '120px' },
      { text: 'Parent', value: 'menuParent', width: '120px' },
      { text: 'Icone', value: 'iconMenu', width: '120px' },
      { text: 'Menu', value: 'nameMenu' },
      { text: 'Rota', value: 'menuRoute' },
      { text: 'Ações', value: 'action', sortable: false, width: '120px' },
    ],
    icons: [
      { icon: 'mdi-archive' },
      { icon: 'mdi-apple-safari' },
      { icon: 'mdi-nutrition' },
      { icon: 'mdi-comment-processing-outline' },
      { icon: 'mdi-console' },
      { icon: 'mdi-contacts' },
      { icon: 'mdi-package' },
      { icon: 'mdi-credit-card' },
      { icon: 'mdi-tag-outline' },
      { icon: 'mdi-theater' },
      { icon: 'mdi-ticket-confirmation' },
      { icon: 'mdi-home' },
      { icon: 'mdi-image' },
      { icon: 'mdi-view-dashboard' },
      { icon: 'mdi-cash-multiple' },
      { icon: 'mdi-account-card-details' },
      { icon: 'mdi-storefront' },
      { icon: 'mdi-inbox' },
      { icon: 'mdi-settings' },
      { icon: 'mdi-history' },
      { icon: 'mdi-file' },
      { icon: 'mdi-developer-board' },
    ],
  }),
  computed: {
    formTitle() {
      return this.editing == false ? 'Adicionar Menu' : 'Editar Menu'
    },
  },
  methods: {
    loadMenus() {
      this.loading = true
      const url = `${baseApiUrl}/menu`

      axios
        .get(url)
        .then((res) => {
          this.menus = res.data
          this.loading = false
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    saveMenu() {
      const url = `${baseApiUrl}/menu`

      axios
        .post(url, this.menu)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadMenus()
          this.reset()
          this.dialog = false
        })
        .catch(showError)
    },
    saveEditedMenu(menu) {
      const url = `${baseApiUrl}/menu/${this.menu.idMenu}`

      axios
        .put(url, this.menu)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadMenus()
          this.reset()
          this.dialog = false
        })
        .catch(showError)
    },
    reset() {
      this.$refs.form.reset()
    },
    editMenu(menu) {
      this.editing = true
      this.menu = Object.assign({}, menu)

      const url = `${baseApiUrl}/menu/${this.menu.idMenu}`
      axios
        .get(url)
        .then(() => (this.dialog = true))
        .catch(showError)
    },
    deleteMenu(menu) {
      const url = `${baseApiUrl}/menu/${menu.idMenu}`
      if (confirm('Tem certeza que deseja desabilitar este menu?')) {
        axios
          .delete(url)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.loadMenus()
          })
          .catch(showError)
      }
    },
    changeEditMode() {
      this.menu = {}
      this.editing = false
      this.dialog = true
    },
  },
  mounted() {
    this.loadMenus()
  },
}
</script>
